import classNames from 'classnames';
import * as React from 'react';

import css from './BooksTermsOfUse.module.scss';

interface Props {
  text: string;
}

const BooksTermsOfUse = ({ text }: Props) => {
  const classes = classNames(css.BooksTermsOfUse, 'notranslate');
  return (
    <div className={classes}>
      <p className={css.BooksTermsOfUse__Text}>{text}</p>
    </div>
  );
};

export default BooksTermsOfUse;
